import $ from "jquery";
import React, { Component } from "react";
import { Field, formValueSelector, change } from 'redux-form';
import { connect } from "react-redux";
import { Row } from "react-foundation";

import { getDoorModels } from "actions";

import Loading from "components/Loading";
import Tick from "components/Tick";

import Image from "../../../components/Image";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import SlickSlider from "../../../components/SlickSlider";
import SeparatingLine from "../../../components/SeparatingLine";
import FormWrapper from "../../FormWrapper";
import FormHeader from "../../../components/FormHeader";
import utils from "../../../utils";
import { updatePreviousSelection } from '../../../actions';
import LottieAnimation from "../../../components/LottieAnimation";

class SelectModel extends Component {
    DisplayModel(value, id, selectedValue) {

        const selected = value.id === selectedValue;

        const selectedClass = selected ? " selected" : "";

        let imageSrc = value.externalImageUrl;

        let { useAnimation, animation } = value;

        return (
            <div key={id} className={!selectedClass}>
                <div className="slick-slide-image-container">
                    <Tick />
                    {useAnimation ?
                        <div className="slick-slide-image">
                            <LottieAnimation className="slick-slide-image" key={value.id} parentProps={{ value, id, selectedValue }} animation={animation} selected={selectedValue === "" ? null : selected} />
                        </div>
                        :
                        <Image
                            src={imageSrc}
                            svg={value.svgImage}
                            alt={""}
                            className="slick-slide-image"
                            ignoreAltSrc={value.externalImageUrl.includes(".gif")}
                        />}
                </div>
            </div>
        );
    }

    render() {
        let { models, input, isPatioOrBifold } = this.props;

        if ($.isEmptyObject(models)) {
            return <Loading />;
        }

        let settings = {
            slidesToShow: isPatioOrBifold ? 3 : 5
        };

        return (
            <div>
                <Row isColumn>
                    <SlickSlider
                        values={models}
                        selectedId={input.value}
                        onDisplay={(value, id) => this.DisplayModel(value, id, input.value, isPatioOrBifold)}
                        onChange={input.onChange}
                        settings={settings}
                    />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class ModelForm extends Component {
    componentDidMount() {
        // TODO: What if we go back
        if(!this.props.isPatioOrBifold)
            this.props.getDoorModels(this.props.DoorTypeId);
    }

    componentDidUpdate() {
        let { selectedModel, models, dispatch, previousSelection } = this.props;
        if (!selectedModel.id) {
            if (models.length > 0) {
                const previousModelExists = models.filter(model => model.id === previousSelection.DoorModelId).length ===1;
                dispatch(change("DoorWizard", "DoorModelId", previousModelExists ? previousSelection.DoorModelId : models[0].id));
            }
        }
    }

    onSubmit(values) {
        let doorModelId = values.DoorModelId;

        let model = utils.getValueById(this.props.models, doorModelId);

        this.props.setStyleSettings(model);

        this.props.updatePreviousSelection({
            DoorModelId: values.DoorModelId
        });

        this.props.onSubmit();
    }

    render() {
        return (
            <form className="ModelForm" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader title={"Pick your model"} subtitle={""} />

                <SeparatingLine />

                <FormWrapper>
                    <Row isColumn style={{ marginTop: '10%' }}>
                        <Field name="DoorModelId" component={SelectModel} models={this.props.models} isPatioOrBifold={this.props.isPatioOrBifold} />
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorModelId = valueSelector(state, "DoorModelId");
    let selectedModel = state.Door.Models.filter(c => c.id === doorModelId)[0] || {};

    let models = state.Door.Models;

    let doorWidth = valueSelector(state, "DoorSize.Width");
    let doorUnit = valueSelector(state, "DoorSize.Unit");
    
    if(doorWidth){
        
        let widthInMm = utils.convertWindowSize(doorWidth, doorUnit, "mm");

        models = models.filter(model => model.minWidth <= widthInMm && model.maxWidth >= widthInMm);
    }

    return {
        models,
        DoorTypeId: valueSelector(state, "DoorTypeId"),
        selectedModel,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getDoorModels, updatePreviousSelection })(ModelForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/uPVC/ModelForm.js